import { render, staticRenderFns } from "./AnimateNumber.vue?vue&type=template&id=51130d54&"
import script from "./AnimateNumber.vue?vue&type=script&lang=js&"
export * from "./AnimateNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51130d54')) {
      api.createRecord('51130d54', component.options)
    } else {
      api.reload('51130d54', component.options)
    }
    module.hot.accept("./AnimateNumber.vue?vue&type=template&id=51130d54&", function () {
      api.rerender('51130d54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/AnimateNumber.vue"
export default component.exports